<div class="row mt-3">
    <div class="col-12 d-flex justify-content-center" style="flex-direction: column;">
        <div class="col-12 d-flex justify-content-center">
            <div class="text-center my-3">
                <img src="../../../../assets/SigaParts_01.png" alt="logo" width="160">
            </div>
        </div>
        <div style="width: 100%; display: flex; justify-content: center;">
            <div class="col-4 d-flex">
                <div class="col-12 card shadow-lg d-flex justify-content-center" style="padding: 5px;">
                    <form [formGroup]="form" style="width: 100%;">
                        <div class="col-12 d-flex justify-content-center" style="flex-direction: column;">
                            <div class="col-12 d-flex justify-content-center">
                                <div class="col-12 d-flex justify-content-center" style="flex-direction:column;">
                                    <div class="col-12 d-flex justify-content-center">
                                        <app-input-field label="Login" formControlName="login" style="width: 90%;"
                                            title="Você não pode alterar seu Login de acesso" isReadOnly="true"></app-input-field>
                                    </div>
                                    <div class="col-12 d-flex justify-content-center">
                                        <app-input-field style="width: 90%;" type="password" label="Senha" formControlName="senha"></app-input-field>
                                    </div>
                                    <div class="col-12 d-flex justify-content-center">
                                        <app-input-field style="width: 90%;" type="password" label="Confirmar Senha" formControlName="senha2"></app-input-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 100%; display: flex; justify-content: end; padding: 5px 28px 5px 5px;">
                            <button class="btn btn-success" (click)="salvarNovaSenha()">Salvar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>